/* eslint-disable @typescript-eslint/member-ordering */
import _flatten from 'lodash/flatten';
import type {
    IChartConfigHelper,
    ILegendItem,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/interface/chart-config.interface';
import type {
    ChartLayoutInfo,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/interface/chart-component.interface';
import type { ISubChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type { BaseChartConfigHelper } from './base-chart-config-helper';
import {
    CHART_TYPE,
    type IChartRendererConfig,
    type IComboChartConfig,
} from '@tencent/chart/lib/chart-ui/interface';
import { AxisCfg } from '@tencent/chart/lib/antv/g2/interface';

export class ComboChartConfigHelper implements IChartConfigHelper {
    public subChartRendererConfigs: IChartRendererConfig[] = [];
    public layout: ChartLayoutInfo;
    private configHelpers: BaseChartConfigHelper[];
    private legendItems: ILegendItem[];
    private getConfigHelper: any;
    private axisPositionMap;

    public constructor(private charts: ISubChartModel[], layout: ChartLayoutInfo, getConfigHelper: any) {
        this.layout = layout;
        this.legendItems = [];
        this.getConfigHelper = getConfigHelper;
        this.setChartRendererConfigs(layout);
    }

    public getConfig(): IComboChartConfig {
        const { subChartRendererConfigs = [] } = this;

        return {
            type: CHART_TYPE.CUSTOM_COMBO_CHART,
            subChartRendererConfigs,
        };
    }

    public getLegendItems(): ILegendItem[] {
        return this.legendItems;
    }

    private setChartRendererConfigs(layout: ChartLayoutInfo) {
        // 创建每个图表的configHelper
        const configHelpers = this.charts
            .map((chart, index) => this.getConfigHelper(chart, layout)).filter(i => !!i) as BaseChartConfigHelper[];

        this.configHelpers = configHelpers;

        this.subChartRendererConfigs = _flatten(configHelpers
            .map(configHelper => configHelper.getConfig().subChartRendererConfigs));

        this.adjustAxisTitle();
    }

    /**
     * 调整组合图相同位置的坐标轴标题布局
     */
    private adjustAxisTitle() {
        this.axisPositionMap = new Map();
        this.subChartRendererConfigs.forEach((config) => {
            const { xAxis, yAxis } = config;
            [xAxis, yAxis].forEach((axis) => {
                axis = axis as AxisCfg;
                if (axis?.title) {
                    const { position } =  axis;
                    const primaryAxis = this.axisPositionMap.get(position);
                    if (primaryAxis && (axis as any).id !== primaryAxis.id) {
                        axis.title.spacing = primaryAxis.label?.style.lineHeight
                        + (primaryAxis.label?.offset * 2) + primaryAxis.title?.style.lineHeight;
                    } else {
                        this.axisPositionMap.set(position, axis);
                    }
                }
            });
        });
    }
}
